export default __webpack_public_path__ + "locales/zh-CN/FillPDFDialog.json?hash=6d9dd8fdc0d82db45a0e17b468d12cbb";